import { render, staticRenderFns } from "./ActiveBalancesTable.vue?vue&type=template&id=62566fee"
import script from "./ActiveBalancesTable.vue?vue&type=script&lang=js"
export * from "./ActiveBalancesTable.vue?vue&type=script&lang=js"
import style0 from "./ActiveBalancesTable.vue?vue&type=style&index=0&id=62566fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports